"use strict"
exports.__esModule = true;
exports.PenFancyIconConfig = {
  name: 'PenFancyIcon',
  height: 512,
  width: 512,
  svgPath: 'M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z',
  yOffset: 0,
  xOffset: 0,
};
exports.PenFancyIcon = require('../createIcon').createIcon(exports.PenFancyIconConfig);
exports["default"] = exports.PenFancyIcon;